import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CalcanealSpurPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Calcaneal Spur</h1>
        <section className="mb-8">
          <p>A calcaneal spur is a bony outgrowth on the heel bone, often causing pain and discomfort, especially when walking or standing. Natural therapies can help reduce inflammation, relieve pain, and support healing without invasive procedures.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Repetitive stress on the heel</li>
            <li>Poor footwear</li>
            <li>Obesity</li>
            <li>Age-related wear and tear</li>
            <li>Inflammatory conditions</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Sharp pain in the heel, especially in the morning</li>
            <li>Discomfort when walking or standing</li>
            <li>Swelling or tenderness</li>
            <li>Difficulty with physical activities</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-inflammatory herbs, soothing oils, and gentle therapies to reduce pain and inflammation, promote healing, and support long-term heel health. Each plan is tailored to your needs for safe, effective relief.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces pain and inflammation</li>
            <li>Promotes natural healing</li>
            <li>No harsh side effects</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Wear supportive footwear</li>
            <li>Maintain a healthy weight</li>
            <li>Practice gentle stretching exercises</li>
            <li>Avoid high-impact activities</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment heal a calcaneal spur?</strong>
            <p>A: Yes, our approach can support healing and symptom relief, especially with early intervention.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for seniors?</strong>
            <p>A: Absolutely, our therapies are gentle and suitable for all ages.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I feel relief?</strong>
            <p>A: Many patients notice improvement within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Step into comfort—book your natural calcaneal spur consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default CalcanealSpurPage; 